import FormBase from "../FormBase";
import Professional from '../../models/Professional'
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import ProfissionalService from "../../services/ProfessionalService";
import { cpfMaskValue } from "../../helpers/Masks/CpfMask";
import OptionItem from "../../models/OptionItem";

export default class PersonalDataForm implements FormBase {

    CPF: FormFieldBase;
    Name: FormFieldBase;
    RG: FormFieldBase;
    CRM: FormFieldBase;
    OM: FormFieldBase;
    BirthDate: FormFieldBase;
    PartnerName: FormFieldBase;
    FatherName: FormFieldBase;
    MotherName: FormFieldBase;
    UsualName: FormFieldBase;
    MaritalStatus: FormFieldBase;
    ColorSkin: FormFieldBase;
    Sex: FormFieldBase;
    StateChoosed: FormFieldBase;
    CellPhone: FormFieldBase;
    TelephonePhone: FormFieldBase;
    BusinessPhone: FormFieldBase;
    Email: FormFieldBase;
    Language: FormFieldBase;
    Nationality: FormFieldBase;

    constructor(CPF: string, Name: string, RG: string, CRM: string,
        PartnerName: string, FatherName: string,
        MotherName: string, UsualName: string, StateChoosed: string,
        CellPhone: string, TelephonePhone: string, BusinessPhone: string, Email: string, Language: string,
        BirthDate?: Date, OM?: string, MaritalStatus?: string, ColorSkin?: string, Sex?: string) {

        this.CPF = new FormFieldBase(CPF, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CPF)]);
        this.Name = new FormFieldBase(Name, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.RG = new FormFieldBase(RG, [new ValidationBase("", ValidationType.RG)]);
        this.CRM = new FormFieldBase(CRM, [new ValidationBase("", ValidationType.CRM)]);
        this.OM = new FormFieldBase(OM, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.BirthDate = new FormFieldBase(BirthDate, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.DATANASCIMENTO), new ValidationBase("A data de nascimento informada é inválida.", ValidationType.DATA)]);
        this.PartnerName = new FormFieldBase(PartnerName, []);
        this.FatherName = new FormFieldBase(FatherName, []);
        this.MotherName = new FormFieldBase(MotherName, []);
        this.UsualName = new FormFieldBase(UsualName, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.MaritalStatus = new FormFieldBase(MaritalStatus, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.StateChoosed = new FormFieldBase(StateChoosed, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.CellPhone = new FormFieldBase(CellPhone, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CELULAR)]);
        this.TelephonePhone = new FormFieldBase(TelephonePhone, [new ValidationBase("O Telefone informado é inválido.", ValidationType.TELEFONE)]);
        this.BusinessPhone = new FormFieldBase(BusinessPhone, [new ValidationBase("O Telefone Comercial informado é inválido.", ValidationType.TELEFONE)]);
        this.Email = new FormFieldBase(Email, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.EMAIL)]);
        this.Language = new FormFieldBase(Language, []);
        
        this.ColorSkin = new FormFieldBase(ColorSkin, []);
        this.Sex = new FormFieldBase(Sex, []);
        this.Nationality = new FormFieldBase("", []);
    }

    static NewInstance(): PersonalDataForm {
        return new PersonalDataForm("", "", "", "", "", "", "", "", "", "", "", "", "", "");
    }

    ValidateToGoNextStep(): string {

        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return ProfissionalService.postInsertOrUpdateProfissional(dataJson, Professional.Id);
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        return await ProfissionalService.getProfissionalByRequest(requestId).then((data: Professional) => {
            this.Name.Value = data.Name;
            this.CPF.Value = cpfMaskValue(data.CPF);
            this.BirthDate.Value = data.BirthDate;
            this.CRM.Value = data.CRM;
            this.RG.Value = data.RG;
            this.OM.Value = data.IssuingAgency;

            if (data.MaritalState !== undefined) {
                this.MaritalStatus.Value = new OptionItem(data.MaritalState.Id, data.MaritalState.Description, data.MaritalState.Id.toString())
            }

            if (data.Nationality !== undefined) {
                this.Nationality.Value = new OptionItem(data.Nationality.Id, data.Nationality.Description, data.Nationality.Id.toString())
            }

            if (data.Sex !== undefined) {
                this.Sex.Value = new OptionItem(data.Sex.Id, data.Sex.Description, data.Sex.Id.toString())
            }

            if (data.ColorSkin !== undefined) {
                this.ColorSkin.Value = new OptionItem(data.ColorSkin.Id, data.ColorSkin.Description, data.ColorSkin.Id.toString())
            }

            if(data.Languages && data.Languages.length > 0 ){

                let languageArray = new Array<OptionItem>();
                for (let index = 0; index < data.Languages.length; index++) {
                    const element = data.Languages[index];
                    languageArray.push(new OptionItem(element.Id, element.Description, element.Id.toString()))
                }

                this.Language.Value = languageArray;
            }


            this.MotherName.Value = data.MotherName;
            this.FatherName.Value = data.FatherName;
            this.PartnerName.Value = data.PartnerName;
            this.BusinessPhone.Value = data.BusinessPhone;
            this.TelephonePhone.Value = data.TelephonePhone;
            this.CellPhone.Value = data.CellPhone;
            this.Email.Value = data.Email;
            this.UsualName.Value = data.UsualName;
        });
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Name":
                return this.Name
            case "CRM":
                return this.CRM
            case "BirthDate":
                return this.BirthDate
            case "RG":
                return this.RG
            case "OM":
                return this.OM
            case "CPF":
                return this.CPF
            case "MaritalStatus":
                return this.MaritalStatus
            case "FatherName":
                return this.FatherName
            case "MotherName":
                return this.MotherName
            case "PartnerName":
                return this.PartnerName
            case "UsualName":
                return this.UsualName
            case "TelephonePhone":
                return this.TelephonePhone
            case "BusinessPhone":
                return this.BusinessPhone
            case "CellPhone":
                return this.CellPhone
            case "Email":
                return this.Email
            case "Language":
                return this.Language
            case "ColorSkin":
                return this.ColorSkin
            case "Sex":
                return this.Sex
            case "Nationality":
                return this.Nationality

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        let languages: any[] = [];

        if (this.Language.Value != null && this.Language.Value.length > 0) {
            this.Language.Value.forEach((element: OptionItem) => {
                languages.push({ id: element.Id, description: element.Text })
            });
        }

        let issuingAgency = null;

        if(this.OM.Value.Value !== undefined){
            issuingAgency = this.OM.Value.Value;
        }else if(this.OM.Value !== undefined){
            issuingAgency = this.OM.Value;
        }

        return {
            "Id": 0,
            "Name": this.Name.Value,
            "CRM": this.CRM.Value,
            "BirthDate": this.BirthDate.Value,
            "RG": this.RG.Value,
            "IssuingAgency": issuingAgency,
            "CPF": this.CPF.Value,
            "IdMaritalStatus": this.MaritalStatus.Value.Id,
            "IdColorSkin": this.ColorSkin.Value?.Id,
            "IdSex": this.Sex.Value?.Id,
            "IdNationality": this.Nationality.Value?.Id,
            "FatherName": this.FatherName.Value,
            "PartnerName": this.PartnerName.Value,
            "MotherName": this.MotherName.Value,
            "UsualName": this.UsualName.Value,
            "TelephonePhone": this.TelephonePhone.Value,
            "BusinessPhone": this.BusinessPhone.Value,
            "CellPhone": this.CellPhone.Value,
            "Email": this.Email.Value,
            "Languages": languages
        }
    }
}